module.exports = __webpack_public_path__ + "img/certificate9.4584320a.jpg";